/**
 * @author Harshitha.k
 * @description 
 */

import React, { useState, useEffect, useRef } from 'react';
import Highlighter from 'react-highlight-words';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { constant } from './Constants';
import { Input, message, Button, Popconfirm } from 'antd';
import {
  DeleteOutlined,
  EditOutlined,
  PlusOutlined,
  SearchOutlined,
  QuestionCircleOutlined
} from '@ant-design/icons';

import localStorage from '../../../utils/localStorage';
import StyledTable from "../../../commons/styles/table";
import {
  selectDashboard,
  deleteDashboard,
} from '../DashboardComponents/DashboardCalls';

const Dashboard = (props) => {
  const [dashboardList, setDashboardList] = useState([]);
  const [translationCache, setTranslationCache] = useState(props.translationCache || []);
  const [userProfile, setUserProfile] = useState(props.userProfile || {});
  const [searchText, setSearchText] = useState('');
  const searchInput = useRef(null);

  useEffect(() => {
    getDashboards();
  }, []);

  useEffect(() => {
    setTranslationCache(props.translationCache);
    setUserProfile(props.userProfile);
  }, [props.translationCache, props.userProfile]);

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type='primary'
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}

          style={{ width: 90, marginRight: 8 }}
        >
          {translation('Search')}
        </Button>
        <Button
          type='primary'
          onClick={() => handleReset(clearFilters)}

          style={{ width: 90 }}
        >
          {translation('Reset')}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record &&
      record[dataIndex] &&
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  });

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };

  const columns = [
    {
      title: 'Dashboard Name',
      dataIndex: 'name',
      key: 'name',
      ...getColumnSearchProps('name'),
      render: (text, record) => {
        return (
          <Link to={{ pathname: `/rubus/dashboard/${record.name}` }}>
            {text}
          </Link>
        );
      }
    },
    {
      title: 'Group Name',
      dataIndex: 'GroupName',
      key: 'GroupName',
      ...getColumnSearchProps('GroupName'),
      render: (text) => (
        <div onClick={() => props.navigate({ pathname: `/rubus/dashboards/${text}` })}>
          {text}
        </div>
      )
    },
    {
      title: 'Action',
      render: (text, record) => (
        <div style={{ display: 'flex', flexDirection: 'row' }}>
        
          <div style={{ marginRight: '10px' }}>
            <Button
              type='primary'
              onClick={(e) => {
                e.preventDefault();
                selectDashboardHandle(record.name);
              }}
            >
              <EditOutlined />
            </Button>
          </div>
          <div style={{ marginRight: '10px' }}>
            <Popconfirm
              title={'Are you Sure that you want to delete dashboard'}
              icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
              onConfirm={() => deleteDashboardHandle(record.Id)}
              okText="Yes"
              cancelText="No"
            >
              <Button
                type='primary'
              >
                <span>
                  <DeleteOutlined />
                </span>
              </Button>
            </Popconfirm>
          </div>
        </div>
      )
    }
  ];

  const translation = (keyword) => {
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  const selectDashboardHandle = async (dashboardName) => {
    if (dashboardName) {
      props.navigate(`/rubus/editdashboard`, { state: dashboardName });
    }
  };

  const deleteDashboardHandle = async (dashboardId) => {
    const msg = await deleteDashboard(dashboardId);
    getDashboards();
    message.info(msg);
  };

  const getDashboards = async () => {
    let dashboards = [];
    let dashboardsdata = await selectDashboard('');
    if (dashboardsdata !== undefined) {
      dashboardsdata.forEach((value, index) => {
        dashboards.push({
          id: index,
          name: value.Name,
          Id: value.Id,
          GroupName: value.GroupName
        });
      });
    }
    setDashboardList(dashboards);
  };

  const siteId = localStorage.get('currentSite');
  let permissionsArray = [];
  userProfile &&
    userProfile['belongsTo'] &&
    userProfile['belongsTo']['sites'] &&
    userProfile['belongsTo']['sites'][siteId] &&
    userProfile['belongsTo']['sites'][siteId]['role'] &&
    userProfile['belongsTo']['sites'][siteId]['role']['Permission']
      .filter((item) => item.resource === 'dashboard')
      .map((name) => permissionsArray.push(name.action));

  return (
    <>
      <div style={{
        display: 'flex',
        flexDirection: 'row-reverse'
      }}>
        <Button
          type='primary'
          style={{ marginBottom: '15px' }}
          onClick={() => props.navigate('/rubus/editdashboard', { state: 'new' })}
        >
          <PlusOutlined />
          <span>
            {translation(`${constant.Add_Dashboard}`)}
          </span>
        </Button>
      </div>
      <StyledTable
        size="small"
        columns={columns}
        dataSource={dashboardList && Array.isArray(dashboardList) ? dashboardList : []}
      />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    userProfile: state.LayoutReducer.getUserProfile,
    translationCache: state.TranslationReducer.translationCache,
  };
};

export default connect(mapStateToProps)(Dashboard);